// extracted by mini-css-extract-plugin
export default {"wrapper":"bottom-nav-bar-mobile-skeleton_wrapper__c3+2u","shimmer":"bottom-nav-bar-mobile-skeleton_shimmer__hWnec","circle":"bottom-nav-bar-mobile-skeleton_circle__HqME3"};